import React from 'react';

import './loading-spinner.scss';

export interface LoadingSpinnerProps {

}
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = (props) => {

  return (
    <div className="spinner">
      <div className="cube1"></div>
      <div className="cube2"></div>
    </div>
  );
};
